import React from "react";
import PropTypes from "prop-types";
import { htmlDecode } from "utils";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as DiscoveryIcon } from "icons/discovery.svg";
import MegaToggle from "@visiblethread/react-components/dist/components/MegaToggle";
import { documentBy } from "constants/discovery";
import { setDocumentBy } from "slices/discovery/discoverySlice";
import RightPart from "./RightPart";

export const TOGGLE_OPTIONS = ["By Theme", "By Content"];

const DiscoveryHeader = ({ title, documentView }) => {
  const docBy = useSelector((state) => state.discovery.config.documentBy);
  const dispatch = useDispatch();

  const handleToggleClick = () => {
    if (docBy === documentBy.theme) {
      dispatch(setDocumentBy(documentBy.content));
    } else {
      dispatch(setDocumentBy(documentBy.theme));
    }
  };

  return (
    <div className="discovery__header" data-testid="discovery-header">
      <div className="discovery__header__left">
        <div className="discovery__header__left__content">
          <DiscoveryIcon />
          <b title={htmlDecode(title)}>{htmlDecode(title)}</b>
          {documentView && (
            <MegaToggle
              options={TOGGLE_OPTIONS}
              selectedOption={
                docBy === documentBy.theme
                  ? TOGGLE_OPTIONS[0]
                  : TOGGLE_OPTIONS[1]
              }
              onClick={handleToggleClick}
            />
          )}
        </div>
      </div>
      <div className="discovery__header__right">
        <RightPart documentView={documentView} />
      </div>
    </div>
  );
};

DiscoveryHeader.propTypes = {
  title: PropTypes.string.isRequired,
  documentView: PropTypes.bool.isRequired,
};

export default DiscoveryHeader;
